import React, { ReactNode } from 'react';
import { ColumnsType } from 'antd/es/table';
import { IDirectMessageReceivers, ISentDirectMessage } from 'providence-types';
import { findFromSelectorOptions, tableSorter } from '@core/utils/methods';
import { actionButtons } from '@models/constants';

const accessCallback = (directMessage: ISentDirectMessage): boolean =>
  !directMessage.completed;

export const DIRECT_MESSAGE_MANAGER_COLUMNS = (
  usersList: IDirectMessageReceivers[],
  editFn: (item: ISentDirectMessage) => void,
  removeFn: (item: ISentDirectMessage) => void,
): ColumnsType<ISentDirectMessage> => [
  {
    key: 'completed',
    dataIndex: 'completed',
    width: 45,
    className: 'empty-header',
    defaultSortOrder: 'ascend',
    sorter: tableSorter(['completed']),
    render: (completed: boolean): ReactNode => (
      <i className={`circle circle_${completed ? 'gray' : 'green'}`} />
    ),
  },
  {
    title: 'Receivers',
    dataIndex: 'receivers',
    key: 'receivers',
    width: 250,
    render: (receivers: string[]): ReactNode => (
      <div className="list">
        {receivers.map((receiver: string) => (
          <span className="list__item" key={receiver}>
            {findFromSelectorOptions(receiver, usersList)}
          </span>
        ))}
      </div>
    ),
  },
  {
    title: 'Message',
    key: 'message',
    dataIndex: 'message',
    className: 'overflow',
  },
  actionButtons({
    editFunc: editFn,
    deleteFunc: removeFn,
    width: 140,
    getEditFuncAccess: accessCallback,
    getDeleteFuncAccess: accessCallback,
  }),
];
